// extracted by mini-css-extract-plugin
export default {"container":"src-components-Layouts-ModalContent-css-module__container--MnnJ6"};